import { Box, ButtonGroup, FormLabel, HStack, Select, Text } from '@chakra-ui/react';
import { Table } from '@tanstack/table-core';

interface PaginationProps {
  table: Table<any>
}

export default function Pagination({ table }: PaginationProps) {
  return (
    <Box maxW="max-content" ml="auto">
      <HStack mt="30px">
        <ButtonGroup spacing="5px">
          <button
            className="border rounded p-1"
            onClick={() => table.firstPage()}
            disabled={!table.getCanPreviousPage()}
          >
            {'<<'}
          </button>
         
          <button
            className="border rounded p-1"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            {'<'}
          </button>

          <span className="flex items-center gap-1">
            <div>Página</div>
            <strong>
              {table.getState().pagination.pageIndex + 1} de{' '}
              {table.getPageCount().toLocaleString()}
            </strong>
          </span>

          <button
            className="border rounded p-1"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            {'>'}
          </button>
          <button
            className="border rounded p-1"
            onClick={() => table.lastPage()}
            disabled={!table.getCanNextPage()}
          >
            {'>>'}
          </button>
        </ButtonGroup>

        

        {/* <span className="flex items-center gap-1">
          | Go to page:
          <input
            type="number"
            min="1"
            max={table.getPageCount()}
            defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              table.setPageIndex(page)
            }}
            className="border p-1 rounded w-16"
          />
        </span> */}
        <HStack ml="30px" w="auto" spacing={0}>
          <FormLabel>Resultados por página:</FormLabel>
          <Select
            value={table.getState().pagination.pageSize}
            onChange={e => {
              table.setPageSize(Number(e.target.value))
            }}
            variant="unstyled"
            w="50px"
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </Select>
        </HStack>

        <Text as="span">
          Exibindo {table.getRowModel().rows.length.toLocaleString()} de{' '}
          {table.getRowCount().toLocaleString()} registros.
        </Text>
      </HStack>
    </Box>
  )
}
